import React, { useEffect, useState } from 'react';
import { SketchPicker } from 'react-color';

const ColorPickerField = ({ initialColor, type, onColorChange }) => {
	const [color, setColor] = useState(ensureHashSymbol(initialColor));
	const [inputValue, setInputValue] = useState(ensureHashSymbol(initialColor).substring(1).toUpperCase());
	const [isPickerOpen, setIsPickerOpen] = useState(false);

	const togglePicker = () => {
		setIsPickerOpen(!isPickerOpen);
	};

	const handleColorChange = (colorResult) => {
		const newColor = colorResult.hex.toUpperCase();
		setColor(newColor);
		setInputValue(newColor.replace('#', ''));
		onColorChange(newColor.replace('#', ''));
		console.log(newColor.replace('#', ''));
	};

	const handleInputChange = (e) => {
		const inputValue = e.target.value.toUpperCase().replace('#', '');
		setInputValue(inputValue);

		if (/^([0-9A-F]{6})$/i.test(inputValue)) {
			const newColor = `#${inputValue}`;
			setColor(newColor);
			onColorChange(inputValue);
		}
	};

	function ensureHashSymbol(input) {
		if (input.startsWith('#')) {
			return input;
		} else {
			return `#${input}`;
		}
	}

	return (
		<div className='colorCorrectionContainer'>
			<div
				className='colorPicker'
				style={{ backgroundColor: color }}
				onClick={()=>togglePicker()}
			/>
			<input
				type='text'
				value={inputValue}
				onChange={handleInputChange}
				maxLength={6} // Limit input to 6 characters (hex code length)
			/>
			{isPickerOpen && (
				<div className="colorPickerPopover">
					<div className="cover" onClick={() => setIsPickerOpen(false)} />
					<SketchPicker color={color} onChange={handleColorChange} />
				</div>
			)}
		</div>
	);
};

export default ColorPickerField;